import { getTelemetryClientConfig } from '@ms/yammer-telemetry-store';

type GetClientId = () => number | undefined;
export const getClientId: GetClientId = () => {
  const { yammerAppClientId } = getTelemetryClientConfig();

  const id = parseInt(yammerAppClientId);

  if (isNaN(id)) {
    return undefined;
  }

  return id;
};
